import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { VaMaterialTableModule } from '@vendasta/uikit';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { ActionListsStoreService } from '../action-lists/action-lists.store.service';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AuxiliaryDataModule, AuxiliaryDataPageModule } from '@vendasta/auxiliary-data-components';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { FieldSelectedForEditService as CreateOrEditCustomFieldService } from '@vendasta/auxiliary-data-components';
import { SideDrawerContainerComponent } from '../common/side-drawer-container/side-drawer-container.component';
import { SideDrawerModule } from '../side-drawer/side-drawer.module';
import { PreviewWelcomeEmailComponent } from '../users/user/preview-welcome-email-dialog.component';
import { BulkImportMapperComponent } from './bulk-import-mapper.component';
import { BulkImportMappingRowComponent } from './bulk-import-mapping-row.component';
import { BulkImportMappingService } from './bulk-import-mapping.service';
import { BulkImportComponent } from './bulk-import.component';
import { BulkImportService } from './bulk-import.service';
import { MapChangeDialogComponent } from './map-change-dialog.component';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AuxiliaryDataPanelComponentModule } from '@vendasta/auxiliary-data-components';

@NgModule({
  declarations: [
    BulkImportComponent,
    BulkImportMapperComponent,
    BulkImportMappingRowComponent,
    MapChangeDialogComponent,
    PreviewWelcomeEmailComponent,
  ],
  imports: [
    MatStepperModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    SideDrawerModule,
    MatButtonModule,
    MaterialFileInputModule,
    MatIconModule,
    FormsModule,
    MatAutocompleteModule,
    MatRadioModule,
    VaMaterialTableModule,
    MatCheckboxModule,
    MatTableModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatListModule,
    MatTooltipModule,
    GalaxyPageModule,
    TranslateModule,
    GalaxyAlertModule,
    AuxiliaryDataPageModule,
    SideDrawerContainerComponent,
    CommonModule,
    AuxiliaryDataModule,
    AuxiliaryDataPageModule,
    AuxiliaryDataPanelComponentModule,
  ],
  exports: [BulkImportComponent, BulkImportMapperComponent, BulkImportMappingRowComponent, MapChangeDialogComponent],
  providers: [ActionListsStoreService, BulkImportService, BulkImportMappingService, CreateOrEditCustomFieldService],
})
export class BulkImportModule {}
